import moment from "moment";

const point = (i: number) => ({
    order: "",
    type: "",
    planEnterDate: moment()
        .add(10 + 10 * i, "minutes")
        .format(),
    geozone: {
        address: "",
        location: {
            type: "",
            coordinates: [],
        },
    },
    client: "",
    cargoOwnerDictionaryItemId: null,
    contactPerson: {
        phoneNumber: "",
        name: "",
    },
    extendedProperties: [],
});

const distributionBidPoint = {
    order: "",
    type: "",
    planEnterDate: moment().add(10, "minutes").format(),
    geozone: {
        address: "",
        location: {
            type: "",
            coordinates: [],
        },
    },
    client: "",
    counterpartyId: null,
    contactPerson: {
        phoneNumber: "",
        name: "",
    },
};

export { point, distributionBidPoint };
